import {Component, OnInit, ViewChild} from '@angular/core';
import {ConfService} from '../conf.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {MatSnackBar} from '@angular/material';
import {MatListModule} from '@angular/material/list';
import {MatListOption} from '@angular/material/list';
import {Observable} from 'rxjs';
import {NgForm} from '@angular/forms';
import {AppComponent} from '../app.component';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {Router} from '@angular/router';
import {DigitaltransformerListenerService} from '../digitaltransformer-listener.service';
const incr = 7;
@Component({
  selector: 'app-digital-transformer',
  templateUrl: './digital-transformer.component.html',
  styleUrls: ['./digital-transformer.component.css']
})
export class DigitalTransformerComponent implements OnInit {

  @ViewChild('myForm', {static: false}) public MyForm: NgForm;
  @ViewChild('myForm1', {static: false}) public MyForm1: NgForm;
  @ViewChild('myForm2', {static: false}) public MyForm2: NgForm;

  constructor(private confPost: ConfService, private _service: ConnecttocrudService, private appComp: AppComponent, private router: Router,
              public platform: LeftpanelComponent, public digitalTransformerListenerInstance: DigitaltransformerListenerService) { }

  APILoadingdB = false;
  buttonClickdB = false;
  importDataDB = true;
  listofTables: any;
  tempListofTables: any;
  listofViews: any;
  listofProcedures: any;
  listofIndexes: any;
  useReferentialKeys: boolean;
  databaseName: string;
  targetDatabase: any;
  dberror = true;
  listofTable = ['All'];
  databases: any;
  listOfObjects: any;


  databaseObjectTypes: any;
  selectedDatabaseObjectTypes: any;
  databaseObjectTypeFilter: any;
  selectedDatatypeFilter: any;
  targetDatabaseType: any;
  transformOptionSelected: any;
  transformOptions = [
    {'name': 'Generate APIs Only - No Data Migration',
      'value': 'apionly'},
    {'name': 'Migrate Data Only - No API Generation',
      'value': 'dataonly'},
    {'name': 'Migrate Data & Generate APIs',
      'value': 'apiwithdata'}
  ];

  referentialKeyOptions = [
    // {'value': 'embed',
    //  'display_name': 'Embed child data with parent entity'},
    {'value': 'reference',
      'display_name': 'Seperate data and create reference'}
  ];
  referentialKeyOptionSelected = 'reference';

  dataMigration = false;
  deploymentPlan: any;
  apiExecutorPlans: any;
  entityPlans: any;
  dataMigrationPlans: any;
  showNextPanel = false;
  showStatusPanel = false;

  partner = localStorage.getItem('partner');
  account = localStorage.getItem('account');

  progress = 0;
  progressMessage: string;

  showDeploymentPlanFlag = true;
  cascadeOnDelete = true;
  cascadeOnUpdate = true;

  listOfTables: any;
  listOfViews: any;
  listOfProcedures: any;
  listOfIndexes: any;

  loading = false;
  loading1 = false;
  buildDeploymentRetries = 0;
  componentLoading = true;

  searchTextInTable:any;
  searchTextInProcedure:any;
  searchTextInViews:any;
  searchTextInIndex:any;
  /*searchTextInName:any;*/
  filterDatabaseObjectTypes(val) {
    this.getDatabaseTypeForDatabaseName(val);
    this.databaseObjectTypeFilter = [];
    this.databaseObjectTypes.filter(items => {
      if (items.database_type === this.selectedDatatypeFilter ) {
        this.databaseObjectTypeFilter.push(items.database_object_types);
      }
    });
    // this.filteredDatabaseObjects = this.databaseObjectTypeFilter[0].database_object_types;
  }
  // getDatabaseObjectTypesForDatabaseName(val) {
  //   this.databases.filter(items => {
  //     if (items.database_name === val) {
  //       this.selectedDatatypeFilter = items.database_type;
  //     }
  //   });
  // }

  getDatabaseTypeForDatabaseName(val) {
    this.databases.filter(items => {
      if (items.database_name === val) {
        this.selectedDatatypeFilter = items.database_type;
      }
    });
  }

  onSelectionChange(){
    setTimeout(() => {
      this.listofTables = this.listOfTables.filter(item => {
        return item.selected;
      });
    })
  }

  buildDeploymentPlanForTransformation(requestModel) {
    this.buildDeploymentRetries += 1;
    if (this.buildDeploymentRetries <= 5) {
      this.confPost.buildDeploymentPlanForDatabaseTransformation(localStorage.getItem('partner'), localStorage.getItem('account'), requestModel).subscribe(data => {
        if (data && data['body']) {
          Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'digitaltransformer_showdeploymentplan_success', 'INFO', data.status, data.statusText, '', requestModel, data, this.router.url)).then(response => {
            const payloadToSend = {
              actions: response
            };
            this.digitalTransformerListenerInstance.digitalTransformerListener.emit({
              type: 'audit',
              id: localStorage.getItem('IdOfSession'),
              payload: payloadToSend
            });
          });
          this.deploymentPlan = data['body'];
          if (this.deploymentPlan) {
            this.apiExecutorPlans = this.deploymentPlan.executorModelDeploymentPlans;
            this.entityPlans = this.deploymentPlan.entityDeploymentPlans;
            this.dataMigrationPlans = this.deploymentPlan.dataMigrationPlans;
            for (const entity of this.entityPlans) {
              entity['deploy_api'] = true;
              if (entity.isAvailable) {
                entity['deploy_api'] = false;
              }
              // entity['override_api'] = entity.isAvailable;
            }
            this.showNextPanel = true;
            this.loading1 = false;
          }
        }
      }, error => {
        Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'digitaltransformer_showdeploymentplan_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), requestModel, error, this.router.url)).then(response => {
          const payloadToSend = {
            actions: response
          };
          this.digitalTransformerListenerInstance.digitalTransformerListener.emit({
            type: 'audit',
            id: localStorage.getItem('IdOfSession'),
            payload: payloadToSend
          });
        });
        setTimeout(() => {
          this.buildDeploymentPlanForTransformation(requestModel);
        }, 6000);
      });
    } else {
      this.loading1 = false;
      this.buildDeploymentRetries = 0;
      this.platform.openSnackBar('Oops!!! Something went wrong. Please try again after sometime.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  buildDeploymentPlanForDatabaseTransformation() {

    Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'digitaltransformer_showdeploymentplan_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
      const payloadToSend = {
        actions: response
      };
      this.digitalTransformerListenerInstance.digitalTransformerListener.emit({
        type: 'audit',
        id: localStorage.getItem('IdOfSession'),
        payload: payloadToSend
      });
    });

    let temp=[]
    this.listofTables.forEach(table => {
      temp.push(table['name']);
    });
    this.loading1 = true;
    if (this.MyForm2.valid) {
      if (this.dataMigration) {
        if (this.MyForm1.valid) {
          this.showDeploymentPlanFlag = false;
          const dbObjectsSelected = {
            'table': this.listofTables,
            'view': this.listofViews,
            'procedure': this.listofProcedures,
            'index': this.listofIndexes
          }
          const requestModel = {
            'sourceDatabaseName': this.databaseName,
            'types': this.selectedDatabaseObjectTypes,
            'databaseObjects': temp,
            'transformOption': this.transformOptionSelected,
            'targetDatabaseName': (this.transformOptionSelected !== 'apionly' ? this.targetDatabase : this.databaseName),
            'useReferentialKey': this.useReferentialKeys,
            'referentialKeyOption': this.referentialKeyOptionSelected,
            'cascadeOnDelete': this.cascadeOnDelete,
            'cascadeOnUpdate': this.cascadeOnUpdate
          };
          this.buildDeploymentPlanForTransformation(requestModel);
        } else {
          alert('Select atleast one Target Database');
          this.loading1 = false;
        }
      } else {
        this.showDeploymentPlanFlag = false;
        const dbObjectsSelected = {
          'table': this.listofTables,
          'view': this.listofViews,
          'procedure': this.listofProcedures,
          'index': this.listofIndexes
        }
        const requestModel = {
          'sourceDatabaseName': this.databaseName,
          'types': this.selectedDatabaseObjectTypes,
          'databaseObjects': temp,
          'transformOption': this.transformOptionSelected,
          'targetDatabaseName': (this.transformOptionSelected !== 'apionly' ? this.targetDatabase : this.databaseName),
          'useReferentialKey': this.useReferentialKeys,
          'referentialKeyOption': this.referentialKeyOptionSelected,
          'cascadeOnDelete': this.cascadeOnDelete,
          'cascadeOnUpdate': this.cascadeOnUpdate
        };
        this.buildDeploymentPlanForTransformation(requestModel);
      }
    } else {
      alert('Select atleast one item in list of objects');
      this.loading1 = false;
    }
  }

  manageProgress() {
    if (this.progress >= 100) {
      this.showNextPanel = true;
      this.showStatusPanel = false;
    } else {
      this.progress = this.progress + incr;
    }
    if (this.progress <= 35) {
      this.progressMessage = 'Setting Up API';
    } else if (this.progress > 35 && this.progress <= 70) {
      this.progressMessage = 'Setting Up Database';
      /*} else if (this.progress > 70 && this.progress <= 98) {
          this.progressMessage = 'Creating dedicated File storage for your account';*/
    } else if (this.progress > 70) {
      this.progressMessage = 'Deploying into Cloud';
    }
  }

  async ngOnInit() {
    // if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
    //   this.platform.initialisePlatform();
    // }
    this.appComp.currentPageTitle = 'Generate API from Database Objects';
    if (this.platform.databases === null || this.platform.databases === undefined || !this.platform.databases) {
      await this.platform.getDatabasesForPartnerAccount();
    }
    if (this.platform.databases === undefined || this.platform.databases === null) {
      this.router.navigateByUrl('/controlplane');
    }
    this.databases = this.platform.databases;
    if (this.platform.databaseObjectTypes && this.platform.databaseObjectTypes !== null && this.platform.databaseObjectTypes !== undefined) {
      this.databaseObjectTypes = this.platform.databaseObjectTypes;
    } else {
      await this.platform.getDatabaseObjectTypes();
      if (this.platform.databaseObjectTypes === undefined || this.platform.databaseObjectTypes === null) {
        this.platform.openSnackBar('Error while fetching databases. Please try again after sometime.', 'Error', {
          duration: 15000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.router.navigateByUrl('/controlplane');
      }
      this.databaseObjectTypes = this.platform.databaseObjectTypes;
      this.componentLoading = false;
    }

    // this.confPost.getTablesFromDatabaseForPartner(localStorage.getItem('partner'), this.databaseName).subscribe(data => {
    //   this.listOfObjects = data;
    // });
  }
  updateObjects() {
    this.filterDatabaseObjectTypes(this.databaseName);
  }

  listObjects() {
    Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'digitaltransformer_listdatabaseobjects_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
      const payloadToSend = {
        actions: response
      };
      this.digitalTransformerListenerInstance.digitalTransformerListener.emit({
        type: 'audit',
        id: localStorage.getItem('IdOfSession'),
        payload: payloadToSend
      });
    });
    this.loading = true;
    if (this.MyForm.valid) {
      if (this.databaseName && this.selectedDatabaseObjectTypes) {
        // this.confPost.getDatabaseObjectsFromDatabaseForPartner(localStorage.getItem('partner'), this.databaseName, this.selectedDatabaseObjectTypes).subscribe(data => {
        //   this.listOfObjects = data;
        // });

        this.confPost.getAllDatabaseObjectsFromDatabaseForPartner(localStorage.getItem('partner'), this.databaseName, this.selectedDatabaseObjectTypes).subscribe(data => {
          Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'digitaltransformer_listdatabaseobjects_success', 'INFO', 200, 'OK', '', {databaseName: this.databaseName, selectedDatabaseObjectTypes: this.selectedDatabaseObjectTypes}, data, this.router.url)).then(response => {
            const payloadToSend = {
              actions: response
            };
            this.digitalTransformerListenerInstance.digitalTransformerListener.emit({
              type: 'audit',
              id: localStorage.getItem('IdOfSession'),
              payload: payloadToSend
            });
          });
          this.loading = false;
          this.listOfObjects = data;
          this.listOfTables = this.listOfObjects.table;
          this.listOfViews = this.listOfObjects.view;
          this.listOfProcedures = this.listOfObjects.procedure;
          this.listOfIndexes = this.listOfObjects.index;
        }, error => {
          Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'digitaltransformer_listdatabaseobjects_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {databaseName: this.databaseName, selectedDatabaseObjectTypes: this.selectedDatabaseObjectTypes}, error, this.router.url)).then(response => {
            const payloadToSend = {
              actions: response
            };
            this.digitalTransformerListenerInstance.digitalTransformerListener.emit({
              type: 'audit',
              id: localStorage.getItem('IdOfSession'),
              payload: payloadToSend
            });
          });
          this.loading = false;
          this.platform.handleErrorGracefully(error, 'Unable to connect to the database. Please check the connection details of database.');
        });
      }
    } else {
      alert('Select atleast one database object type');
      this.loading = false;
    }
  }

  updateTransformOptions(){
    if (this.transformOptionSelected === 'apionly') {
      this.dataMigration = false;
      this.targetDatabase = null;
    } else {
      this.dataMigration = true;
    }
  }

  validateDatabaseSelection() {
    this.databases.forEach(database => {
      if (database.database_name === this.targetDatabase) {
        this.targetDatabaseType = database.database_type;
      }
    });

    if (this.targetDatabase === this.databaseName) {
      this.platform.openSnackBar('Source and Target Databases can not be same.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }



  createAPIByDB() {
    this.buttonClickdB = true;
    this.dberror = false;
    const crudAPI = {
      'database_name': this.databaseName,
      'listOfTables': this.listofTables,
      'useReferentialKeys': this.useReferentialKeys,
      'targetDatabase': (this.targetDatabase == null ? 'default' : this.targetDatabase),
      'importData': this.importDataDB
    };

    this.confPost.createAPIFromDB(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
      this.platform.openSnackBar('API Created successfully', 'Success', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.APILoadingdB = true;

    }, error => {
      this.dberror = true;
      this.APILoadingdB = true;
      this.platform.openSnackBar(error.error.message, 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

  createAPIByDatabaseObjects() {
    this.buttonClickdB = true;
    this.APILoadingdB = false;
    this.dberror = false;
    // this.statusTable = [];
    this.listofTables.forEach(table => {
      const crudAPI = {
        'database_name': this.databaseName,
        'tableName': table['name'],
        'useReferentialKeys': this.useReferentialKeys,
        'targetDatabase': (this.targetDatabase == null ? 'default' : this.targetDatabase),
        'importData': this.importDataDB
      };
      this.createApiForTable(crudAPI);
    });
    this.buttonClickdB = false;
    this.APILoadingdB = true;
  }

  async createApiForTable(crudAPI) {
    await this.confPost.createAPIByDBObjects(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
      const stat = {
        'tableName' : crudAPI.tableName,
        'apistatus' : 'Success',
        'databasestatus' : 'Success',
        'deploystatus' : 'Success',
        'gatewaystatus' : 'Success'
      };
    }, error => {
      this.dberror = true;
      const stat = {
        'tableName' : crudAPI.tableName,
        'apistatus' : 'Failed',
        'databasestatus' : 'Failed',
        'deploystatus' : 'Failed',
        'gatewaystatus' : 'Failed'
      };
    });
  }

}
